import React from 'react'
import { Tooltip } from 'react-tippy'
import 'react-tippy/dist/tippy.css'

import styled from 'styled-components'

import { palette } from '../../styles/variables'
import exclamationMark from '../../styles/assets/exclamation-mark.svg'

const ExclamationImg = styled.img((props) => ({
  width: 16,
  height: 16,
  marginLeft: 3,
  ...(props.style || {}),
}))

const MessageBox = styled.span({
  color: palette.white,
  fontSize: '14px',
})

export default ({ show, message, ...rest }) => {
  if (!show) return null

  return (
    <Tooltip
      disabled={!show}
      theme="orange"
      {...rest}
      html={<MessageBox>{message}</MessageBox>}
      popperOptions={{
        modifiers: {
          addZIndex: {
            enabled: true,
            order: 810,
            fn: (data) => ({
              ...data,
              styles: {
                ...data.styles,
                zIndex: 99999,
              },
            }),
          },
        },
      }}
    >
      <ExclamationImg src={exclamationMark} alt="!" />
    </Tooltip>
  )
}
